/** Pure decision logic, extracted so the guards unit-test without rendering the router. */

export interface GuardUser {
  email?: string;
  isEmailVerified: boolean;
  profileComplete?: boolean;
  accountType?: 'STAFF' | 'CANDIDATE';
  needsAccountTypeSelection?: boolean;
}

/** Only newly-created external identities are sent to the one-time type chooser. */
export function externalAccountTypeDecision(user: GuardUser | null, isFetched: boolean): GuardDecision {
  if (!isFetched) return { kind: 'loading' };
  if (user?.needsAccountTypeSelection === true) {
    return { kind: 'redirect', to: '/account-type' };
  }
  return { kind: 'allow' };
}

export type GuardDecision =
  | { kind: 'loading' }
  | { kind: 'redirect'; to: string }
  | { kind: 'allow' };

/** Gates ONLY users who actually have an email — phone-only users must not be trapped at /verify-email. */
export function emailVerifiedDecision(user: GuardUser | null, isFetched: boolean): GuardDecision {
  if (!isFetched) return { kind: 'loading' };
  if (user?.email && !user.isEmailVerified) return { kind: 'redirect', to: '/verify-email' };
  return { kind: 'allow' };
}

/** Redirects only when `profileComplete` is explicitly false; an absent flag passes. */
export function profileCompleteDecision(user: GuardUser | null, isFetched: boolean): GuardDecision {
  if (!isFetched) return { kind: 'loading' };
  if (user && user.profileComplete === false) return { kind: 'redirect', to: '/onboarding' };
  return { kind: 'allow' };
}
